<script>
  import { onMount } from "svelte";
  import CommandNav from "./components/CommandNav.svelte";
  import MenuScreen from "./components/MenuScreen.svelte";
  import GameScreens from "./components/GameScreens.svelte";
  import SiteFooter from "./components/SiteFooter.svelte";

  onMount(() => {
    void import("../js/main.js");
  });
</script>

<div id="app">
  <CommandNav />
  <div id="live-region" class="sr-only" role="status" aria-live="polite" aria-atomic="true"></div>
  <main>
    <MenuScreen />
    <GameScreens />
  </main>
  <SiteFooter />
</div>
